"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,10H20.64a12.25,12.25,0,0,0-.77-2.33l2-2a.51.51,0,0,0,0-.71L19.07,2.1a.51.51,0,0,0-.71,0l-2,2A12.48,12.48,0,0,0,14,3.36V.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V3.36a12.25,12.25,0,0,0-2.33.77l-2-2a.51.51,0,0,0-.71,0L2.1,4.93a.5.5,0,0,0,0,.71l2,2A13.84,13.84,0,0,0,3.35,10H.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H3.35a13.84,13.84,0,0,0,.78,2.33l-2,2a.5.5,0,0,0,0,.71L4.93,21.9a.51.51,0,0,0,.71,0l2-2a13.84,13.84,0,0,0,2.33.78V23.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V20.65a13.84,13.84,0,0,0,2.33-.78l2,2a.51.51,0,0,0,.71,0l2.83-2.83a.51.51,0,0,0,0-.71l-2-2A13.84,13.84,0,0,0,20.65,14H23.5a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,23.5,10ZM12,17.5A5.5,5.5,0,1,1,17.5,12,5.51,5.51,0,0,1,12,17.5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.19",
    y: "9.19",
    width: "5.61",
    height: "5.61",
    rx: "0.5",
    fill: "#004864"
  }));
};

exports["default"] = _default;